import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page-content",
  key: "page"
};
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import TheHeader from './components/TheHeader.vue';
import TheFooter from './components/TheFooter.vue';
export default {
  __name: 'App',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const open = computed(() => store.state.menuOpen);
    const routeName = computed(() => route.name);
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["main-content", [{
          'menu-open': open.value
        }, routeName.value]])
      }, [_createElementVNode("div", _hoisted_1, [routeName.value !== 'notFound' ? (_openBlock(), _createBlock(TheHeader, {
        key: 0
      })) : _createCommentVNode("", true), (_openBlock(), _createBlock(_component_router_view, {
        key: routeName.value
      }))]), routeName.value !== 'notFound' ? (_openBlock(), _createBlock(TheFooter, {
        key: 0
      })) : _createCommentVNode("", true)], 2);
    };
  }
};